module.exports = ".form-horizontal.titulo {\r\n    margin-top: 25px !important;\r\n}"